import React from 'react';
import '../template-file-css/document-file-template.css';


export const AFHS_OpenNoteneticRequest = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='AFHS_OpenNoteneticRequest' className='file-pdf-document'>
            <div className='file-template'>

                <p className='w-750'><h3>OPEN NOTENETIC REQUEST FORM </h3>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Service code box needed:</span>
                    <input type='radio' id='rbServiceCodeBoxNeeded_Approved' name='rbServiceCodeBoxNeeded' className='add-only' value='Approved' /> Approved - Agency Issue&nbsp;&nbsp;&nbsp;
                    <input type='radio' id='rbServiceCodeBoxNeeded_Penalty' name='rbServiceCodeBoxNeeded' className='add-only' value='Penalty' /> Approved with Penalty&nbsp;&nbsp;&nbsp;
                    <input type='radio' id='rbServiceCodeBoxNeeded_Denied' name='rbServiceCodeBoxNeeded' className='add-only' value='Denied' /> Denied</p>

                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Staff Name:</span></td>
                        <td className='w-250'>
                            <span className='eleHeader'>Position</span></td>
                        <td className='w-250'>
                            <span className='eleHeader'>Date:</span></td>

                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtStaffName' name='txtStaffName' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='text' id='txtPosition' name='txtPosition' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='date' id='txtDate' name='txtDate' className='add-only' /></td>

                    </tr>
                </table>

                <p className='w-750'>
                    <b>Open notenetic forms should not go past 7 days from the date of service</b>
                    <br />
                    <span className='eleHeader'>Reason:</span>
                    <textarea id='txtMedicalHistory' name='txtMedicalHistory' placeholder='Staff Use Only:' className='add-only'></textarea>
                </p>

                <p className='w-750'>Pay Period for which notes are entered:
                    <input type='text' id='txtPayPeriodForWhich_1' name='txtPayPeriodForWhich_1' className='add-only w-80 custom-add-only' /> to
                    <input type='text' id='txtPayPeriodForWhich_2' name='txtPayPeriodForWhich_2' className='add-only w-80 custom-add-only' /> Total Hours To Be Compensated
                    <input type='text' id='txtPayPeriodForWhich_3' name='txtPayPeriodForWhich_3' className='add-only w-80 custom-add-only' />
                </p>

                <table>
                    <tr>
                        <td className='w-225'>
                            <span className='eleHeader'>Client Name</span></td>
                        <td className='w-150'>
                            <span className='eleHeader'>Date of Service</span></td>
                        <td className='w-275'>
                            <span className='eleHeader'>Date of Note Entry and Service Code </span></td>
                        <td className='w-100'>
                            <span className='eleHeader'>Total Hours Billed</span></td>

                    </tr>
                    <tr>
                        <td className='w-225'>
                            <input type='text' id='txtClientName_1' name='txtClientName_1' className='add-only' /></td>
                        <td className='w-150'>
                            <input type='date' id='txtDateofService_1' name='txtDateofService_1' className='add-only' /></td>
                        <td className='w-150'>
                            <input type='date' id='txtDateOfNoteEntryAndService_1' name='txtDateOfNoteEntryAndService_1' className='add-only' /></td>
                        <td className='w-125'>
                            <input type='text' id='txtServiceCode_1' name='txtServiceCode_1' placeholder='Service Code' className='add-only' /></td>
                        <td className='w-100'>
                            <input type='text' id='txtTotalHoursBilled_1' name='txtTotalHourBilled_1' className='add-only' /></td>

                    </tr>
                    <tr>
                        <td className='w-225'>
                            <input type='text' id='txtClientName_2' name='txtClientName_2' className='add-only' /></td>
                        <td className='w-150'>
                            <input type='date' id='txtDateofService_2' name='txtDateofService_2' className='add-only' /></td>
                        <td className='w-150'>
                            <input type='date' id='txtDateOfNoteEntryAndService_2' name='txtDateOfNoteEntryAndService_2' className='add-only' /></td>
                        <td className='w-125'>
                            <input type='text' id='txtServiceCode_2' name='txtServiceCode_2' placeholder='Service Code' className='add-only' /></td>
                        <td className='w-100'>
                            <input type='text' id='txtTotalHoursBilled_2' name='txtTotalHourBilled_2' className='add-only' /></td>

                    </tr>
                    <tr>
                        <td className='w-225'>
                            <input type='text' id='txtClientName_3' name='txtClientName_3' className='add-only' /></td>
                        <td className='w-150'>
                            <input type='date' id='txtDateofService_3' name='txtDateofService_3' className='add-only' /></td>
                        <td className='w-150'>
                            <input type='date' id='txtDateOfNoteEntryAndService_3' name='txtDateOfNoteEntryAndService_3' className='add-only' /></td>
                        <td className='w-125'>
                            <input type='text' id='txtServiceCode_3' name='txtServiceCode_3' placeholder='Service Code' className='add-only' /></td>
                        <td className='w-100'>
                            <input type='text' id='txtTotalHoursBilled_3' name='txtTotalHourBilled_3' className='add-only' /></td>

                    </tr>
                    <tr>
                        <td className='w-225'>
                            <input type='text' id='txtClientName_4' name='txtClientName_4' className='add-only' /></td>
                        <td className='w-150'>
                            <input type='date' id='txtDateofService_4' name='txtDateofService_4' className='add-only' /></td>
                        <td className='w-150'>
                            <input type='date' id='txtDateOfNoteEntryAndService_4' name='txtDateOfNoteEntryAndService_4' className='add-only' /></td>
                        <td className='w-125'>
                            <input type='text' id='txtServiceCode_4' name='txtServiceCode_4' placeholder='Service Code' className='add-only' /></td>
                        <td className='w-100'>
                            <input type='text' id='txtTotalHoursBilled_4' name='txtTotalHourBilled_4' className='add-only' /></td>

                    </tr>
                    <tr>
                        <td className='w-225'>
                            <input type='text' id='txtClientName_5' name='txtClientName_5' className='add-only' /></td>
                        <td className='w-150'>
                            <input type='date' id='txtDateofService_5' name='txtDateofService_5' className='add-only' /></td>
                        <td className='w-150'>
                            <input type='date' id='txtDateOfNoteEntryAndService_5' name='txtDateOfNoteEntryAndService_5' className='add-only' /></td>
                        <td className='w-125'>
                            <input type='text' id='txtServiceCode_5' name='txtServiceCode_5' placeholder='Service Code' className='add-only' /></td>
                        <td className='w-100'>
                            <input type='text' id='txtTotalHoursBilled_5' name='txtTotalHourBilled_5' className='add-only' /></td>

                    </tr>
                    <tr>
                        <td className='w-225'>
                            <input type='text' id='txtClientName_6' name='txtClientName_6' className='add-only' /></td>
                        <td className='w-150'>
                            <input type='date' id='txtDateofService_6' name='txtDateofService_6' className='add-only' /></td>
                        <td className='w-150'>
                            <input type='date' id='txtDateOfNoteEntryAndService_6' name='txtDateOfNoteEntryAndService_6' className='add-only' /></td>
                        <td className='w-125'>
                            <input type='text' id='txtServiceCode_6' name='txtServiceCode_6' placeholder='Service Code' className='add-only' /></td>
                        <td className='w-100'>
                            <input type='text' id='txtTotalHoursBilled_6' name='txtTotalHourBilled_6' className='add-only' /></td>

                    </tr>
                    <tr>
                        <td className='w-225'>
                            <input type='text' id='txtClientName_7' name='txtClientName_7' className='add-only' /></td>
                        <td className='w-150'>
                            <input type='date' id='txtDateofService_7' name='txtDateofService_7' className='add-only' /></td>
                        <td className='w-150'>
                            <input type='date' id='txtDateOfNoteEntryAndService_7' name='txtDateOfNoteEntryAndService_7' className='add-only' /></td>
                        <td className='w-125'>
                            <input type='text' id='txtServiceCode_7' name='txtServiceCode_7' placeholder='Service Code' className='add-only' /></td>
                        <td className='w-100'>
                            <input type='text' id='txtTotalHoursBilled_7' name='txtTotalHourBilled_7' className='add-only' /></td>

                    </tr>
                    <tr>
                        <td className='w-225'>
                            <input type='text' id='txtClientName_8' name='txtClientName_8' className='add-only' /></td>
                        <td className='w-150'>
                            <input type='date' id='txtDateofService_8' name='txtDateofService_8' className='add-only' /></td>
                        <td className='w-150'>
                            <input type='date' id='txtDateOfNoteEntryAndService_8' name='txtDateOfNoteEntryAndService_8' className='add-only' /></td>
                        <td className='w-125'>
                            <input type='text' id='txtServiceCode_8' name='txtServiceCode_8' placeholder='Service Code' className='add-only' /></td>
                        <td className='w-100'>
                            <input type='text' id='txtTotalHoursBilled_8' name='txtTotalHourBilled_8' className='add-only' /></td>

                    </tr>
                    <tr>
                        <td className='w-225'>
                            <input type='text' id='txtClientName_9' name='txtClientName_9' className='add-only' /></td>
                        <td className='w-150'>
                            <input type='date' id='txtDateofService_9' name='txtDateofService_9' className='add-only' /></td>
                        <td className='w-150'>
                            <input type='date' id='txtDateOfNoteEntryAndService_9' name='txtDateOfNoteEntryAndService_9' className='add-only' /></td>
                        <td className='w-125'>
                            <input type='text' id='txtServiceCode_9' name='txtServiceCode_9' placeholder='Service Code' className='add-only' /></td>
                        <td className='w-100'>
                            <input type='text' id='txtTotalHoursBilled_9' name='txtTotalHourBilled_9' className='add-only' /></td>

                    </tr>
                    <tr>
                        <td className='w-225'>
                            <input type='text' id='txtClientName_10' name='txtClientName_10' className='add-only' /></td>
                        <td className='w-150'>
                            <input type='date' id='txtDateofService_10' name='txtDateofService_10' className='add-only' /></td>
                        <td className='w-150'>
                            <input type='date' id='txtDateOfNoteEntryAndService_10' name='txtDateOfNoteEntryAndService_10' className='add-only' /></td>
                        <td className='w-125'>
                            <input type='text' id='txtServiceCode_10' name='txtServiceCode_10' placeholder='Service Code' className='add-only' /></td>
                        <td className='w-100'>
                            <input type='text' id='txtTotalHoursBilled_10' name='txtTotalHourBilled_10' className='add-only' /></td>

                    </tr>
                    <tr>
                        <td className='w-225'>
                            <input type='text' id='txtClientName_11' name='txtClientName_11' className='add-only' /></td>
                        <td className='w-150'>
                            <input type='date' id='txtDateofService_11' name='txtDateofService_11' className='add-only' /></td>
                        <td className='w-150'>
                            <input type='date' id='txtDateOfNoteEntryAndService_11' name='txtDateOfNoteEntryAndService_11' className='add-only' /></td>
                        <td className='w-125'>
                            <input type='text' id='txtServiceCode_11' name='txtServiceCode_11' placeholder='Service Code' className='add-only' /></td>
                        <td className='w-100'>
                            <input type='text' id='txtTotalHoursBilled_11' name='txtTotalHourBilled_11' className='add-only' /></td>

                    </tr>
                    <tr>
                        <td className='w-225'>
                            <input type='text' id='txtClientName_12' name='txtClientName_12' className='add-only' /></td>
                        <td className='w-150'>
                            <input type='date' id='txtDateofService_12' name='txtDateofService_12' className='add-only' /></td>
                        <td className='w-150'>
                            <input type='date' id='txtDateOfNoteEntryAndService_12' name='txtDateOfNoteEntryAndService_12' className='add-only' /></td>
                        <td className='w-125'>
                            <input type='text' id='txtServiceCode_12' name='txtServiceCode_12' placeholder='Service Code' className='add-only' /></td>
                        <td className='w-100'>
                            <input type='text' id='txtTotalHoursBilled_12' name='txtTotalHourBilled_12' className='add-only' /></td>

                    </tr>
                    <tr>
                        <td className='w-225'>
                            <input type='text' id='txtClientName_13' name='txtClientName_13' className='add-only' /></td>
                        <td className='w-150'>
                            <input type='date' id='txtDateofService_13' name='txtDateofService_13' className='add-only' /></td>
                        <td className='w-150'>
                            <input type='date' id='txtDateOfNoteEntryAndService_13' name='txtDateOfNoteEntryAndService_13' className='add-only' /></td>
                        <td className='w-125'>
                            <input type='text' id='txtServiceCode_13' name='txtServiceCode_13' placeholder='Service Code' className='add-only' /></td>
                        <td className='w-100'>
                            <input type='text' id='txtTotalHoursBilled_13' name='txtTotalHourBilled_13' className='add-only' /></td>

                    </tr>

                </table>
                <p className='w-750'><span className='eleHeader'>Administrative Use Only By Manager :</span>
                    <input type='text' id='txAdministrativeManager' name='txAdministrativeManager' className='add-only' /> <br />
                    <span className='eleHeader'>Status</span>
                    <input type='radio' id='rbAdministrativeManager_Approved' name='rbAdministrativeManager' className='add-only' value='Approved' /> Approved &nbsp;&nbsp;
                    <input type='radio' id='rbAdministrativeManager_Penalty' name='rbAdministrativeManager' className='add-only' value='Penalty' /> Approved with Penalty&nbsp;&nbsp;
                    <input type='radio' id='rbAdministrativeManager_Denied' name='rbAdministrativeManager' className='add-only' value='Denied' /> Denied
                </p>
                <p className='w-750'>Requested Notenetic Calendar Open Date From:
                    <input type='date' id='txtRequestedSharenoteCalandarOpen_1' name='txtRequestedSharenoteCalandarOpen_1' className='add-only w-150 custom-add-only' /> to
                    <input type='date' id='txtRequestedSharenoteCalandarOpen_2' name='txtRequestedSharenoteCalendarOpen_2' className='add-only w-150 custom-add-only' />

                </p>

                <p className='w-750'>Pay Period Start &nbsp;
                    <input type='date' id='txtPayPeriodStart' name='txtPayPeriodStart' className='add-only w-150 custom-add-only' /> Pay Period End &nbsp;
                    <input type='date' id='txtPayPeriodEnd' name='txtPayPeriodEnd' className='add-only w-150 custom-add-only' />

                </p>

                <p className='w-750'><span className='eleHeader'>Approved Pay Date</span>
                    <input type='date' id='txtApprovedPayDate' name='txtApprovedPayDate' className='add-only' />
                </p>

                <table>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Refer Contractor for Documentation Training:</span>
                            <input type='radio' id='rbReferContractorForDocumentation_Yes' name='rbReferContractorForDocumentation' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbReferContractorForDocumentation_No' name='rbReferContractorForDocumentation' className='add-only' value='No' /> No
                        </td>
                        <td className='w-375'><span className='eleHeader'>Planned Date and time:</span>
                            <input type='date' id='txtPlannedDateTime' name='txtPlannedDateTime' className='add-only' />
                        </td>
                    </tr>


                </table>






            </div>
        </form>

    )
}   